import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  AppBar, Toolbar, Box, Button, Container,
  IconButton, Drawer, List, ListItem, ListItemText
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();
  const [open, setOpen] = useState(false);

  if (
  location.pathname.startsWith('/admin') ||
  location.pathname.startsWith('/ourproducts')
)
  return null;

  const navLinks = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Courses', path: '/courses' },
    { label: 'Certifications', path: '/certifications' },
    { label: 'Our Branches', path: '/branches' },
    { label: 'Contact', path: '/contact' },
    { label: 'Verify Result', path: '/verify-result' },
    { label: 'Safety Products', path: '/ourproducts' }
  ];

  return (
    <AppBar position="sticky" sx={{ bgcolor: '#1976d2' }}>
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Link
  to="/"
  style={{
    textDecoration: 'none',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  }}
>
  <Box
    sx={{
      backgroundColor: '#fff',
      p: '4px',
      borderRadius: '6px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
    }}
  >
    <Box
      component="img"
      src="/Kavyalogo1.jpeg"
      alt="Kavya Logo"
      sx={{
        height: { xs: 40, md: 52 },   // 🔥 bigger logo
        width: 'auto',
        display: 'block'
      }}
    />
  </Box>

  <Box>
  <Box
    sx={{
      fontWeight: 700,
      fontSize: '1.2rem',
      lineHeight: 1.1
    }}
  >
    KAVYARG
  </Box>

  <Box
    sx={{
      fontSize: '0.75rem',
      opacity: 0.9
    }}
  >
    Global India Pvt Ltd
  </Box>
</Box>
</Link>



          {/* Desktop */}
          <Box
  sx={{
    display: { xs: 'none', md: 'flex' },
    gap: 1,
    flexWrap: 'nowrap',
    alignItems: 'center'
  }}
>
            {navLinks.map(link => (
  link.label === 'Safety Products' ? (
    <Button
  key={link.path}
  color="inherit"
  component="a"
  href={link.path}
  target="_blank"
  rel="noopener noreferrer"
  sx={{
    whiteSpace: 'nowrap',
    fontSize: '0.85rem',
    px: 1
  }}
>
      {link.label}
    </Button>
  ) : (
    <Button
  key={link.path}
  color="inherit"
  component={Link}
  to={link.path}
  sx={{
    whiteSpace: 'nowrap',
    fontSize: '0.85rem',
    px: 1
  }}
>
      {link.label}
    </Button>
  )
))}
            {isAuthenticated ? (
              <Button color="inherit" onClick={logout}>Logout</Button>
            ) : (
              <Button color="inherit" component={Link} to="/login">Login</Button>
            )}
          </Box>

          {/* Mobile */}
          <IconButton sx={{ display: { xs: 'block', md: 'none' }, color: '#fff' }} onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </Container>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
  <Box sx={{ width: 250 }}>
    <List>

      {navLinks.map(link => (
        link.label === 'Safety Products' ? (
          <ListItem
            button
            key={link.path}
            component="a"
            href={link.path}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
          >
            <ListItemText primary={link.label} />
          </ListItem>
        ) : (
          <ListItem
            button
            key={link.path}
            component={Link}
            to={link.path}
            onClick={() => setOpen(false)}
          >
            <ListItemText primary={link.label} />
          </ListItem>
        )
      ))}

      {isAuthenticated ? (
        <ListItem
          button
          onClick={() => {
            logout();
            setOpen(false);
          }}
        >
          <ListItemText primary="Logout" />
        </ListItem>
      ) : (
        <ListItem
          button
          component={Link}
          to="/login"
          onClick={() => setOpen(false)}
        >
          <ListItemText primary="Login" />
        </ListItem>
      )}

    </List>
  </Box>
</Drawer>
    </AppBar>
  );
};

export default Navbar;
